// extracted by mini-css-extract-plugin
module.exports = {"Container":"Accounts_Container__32Z-7","Header":"Accounts_Header__380XS","Collection":"Accounts_Collection__3Sy7B"};